import * as charts from './charts';
import * as table from './table';

export const autoRecallAnalyticsDemoData = {
  charts,
  table,
};
